"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Tooltip = /*#__PURE__*/function (_React$PureComponent) {
  function Tooltip(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Tooltip);
    _this = _callSuper(this, Tooltip, [props]);
    _this.setWrapperRef = _this.setWrapperRef.bind(_this);
    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(Tooltip, _React$PureComponent);
  return (0, _createClass2["default"])(Tooltip, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var hideAction = this.props.hideAction;
      if (hideAction) {
        document.addEventListener('mousedown', this.handleClick);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var hideAction = this.props.hideAction;
      if (hideAction) {
        document.removeEventListener('mousedown', this.handleClick);
      }
    }
  }, {
    key: "setWrapperRef",
    value: function setWrapperRef(node) {
      this.wrapperRef = node;
    }
  }, {
    key: "handleClick",
    value: function handleClick(ev) {
      var hideAction = this.props.hideAction;
      if (this.wrapperRef && !this.wrapperRef.contains(ev.target)) {
        hideAction();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        shown = _this$props.shown,
        width = _this$props.width,
        content = _this$props.content,
        animated = _this$props.animated,
        children = _this$props.children,
        className = _this$props.className;
      return shown ? /*#__PURE__*/_react["default"].createElement(StyledRoot, {
        ref: this.setWrapperRef
      }, /*#__PURE__*/_react["default"].createElement(StyledTooltip, {
        animated: animated,
        width: width,
        className: className
      }, children || content)) : null;
    }
  }]);
}(_react["default"].PureComponent);
Tooltip.propTypes = {
  shown: _propTypes["default"].bool,
  width: _propTypes["default"].number,
  animated: _propTypes["default"].bool,
  children: _propTypes["default"].node,
  content: _propTypes["default"].string,
  hideAction: _propTypes["default"].func,
  className: _propTypes["default"].string
};
Tooltip.defaultProps = {
  width: 250,
  shown: false,
  content: null,
  children: null,
  animated: false,
  className: '',
  hideAction: function hideAction() {
    return null;
  }
};
var StyledRoot = _styledComponents["default"].div.withConfig({
  displayName: "Tooltip__StyledRoot",
  componentId: "sc-1c748r8-0"
})(["height:0;z-index:9;width:100%;position:relative;"]);
var StyledTooltip = _styledComponents["default"].div.withConfig({
  displayName: "Tooltip__StyledTooltip",
  componentId: "sc-1c748r8-1"
})(["left:50%;bottom:30px;color:black;padding:10px;text-align:left;background:white;position:absolute;border-radius:10px;border:1px solid #00000017;box-shadow:0 0 9px -2px rgba(0,0,0,0.2);:before,:after{width:0;height:0;content:'';position:absolute;}:before{bottom:-10px;left:calc(50% - 10px);border-top:10px solid #e8e8e8;border-left:10px solid transparent;border-right:10px solid transparent;}:after{bottom:-9px;left:calc(50% - 9px);border-top:9px solid #fff;border-left:9px solid transparent;border-right:9px solid transparent;}", " ", " @keyframes slide{from{opacity:0;margin-top:50px;}}"], function (p) {
  return p.width && "\n    width: ".concat(p.width, "px;\n    margin-left: calc(-").concat(p.width, "px/2);\n  ");
}, function (p) {
  return p.animated && "\n    animation: slide .2s ease-in-out;\n  ";
});
var _default = exports["default"] = Tooltip;